export function initRecaptcha() {
    document.addEventListener('submit', async (e) => {
        const form = e.target;
        
        if (!form.matches('[data-ynform=true]')) {
            return; 
        }

        if (form.getAttribute('data-captcha-ready') === 'true') {
            form.removeAttribute('data-captcha-ready');
            return; 
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        const method = form.getAttribute('method') || 'POST';

        if (method.toLowerCase() === 'post' && typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
            try {
                
                const token = await new Promise((resolve, reject) => {
                    grecaptcha.enterprise.ready(async () => {
                        try {
                            const t = await grecaptcha.enterprise.execute('6Lc8iSItAAAAAJV8hchF0kHcI6oggbMWczTqSaJk', { action: 'LOGIN' });
                            resolve(t);
                        } catch (err) {
                            reject(err);
                        }
                    });
                });
               
                let hiddenInput = form.querySelector('input[name="g-recaptcha-response"]');
                if (!hiddenInput) {
                    hiddenInput = document.createElement('input');
                    hiddenInput.type = 'hidden';
                    hiddenInput.name = 'g-recaptcha-response';
                    form.appendChild(hiddenInput);
                }
                hiddenInput.value = token;

                form.setAttribute('data-captcha-ready', 'true');
                console.log("Payload armed with reCaptcha token. Resubmitting ...");
                form.requestSubmit();

            } catch (captchaError) {
                console.error('Google reCAPTCHA execution failed:', captchaError);
                form.setAttribute('data-captcha-ready', 'true');
                form.requestSubmit();
            }
        } else {
            console.warn("! reCAPTCHA skipped. Reasons: Not a POST method, or the Google script element is missing from the HTML <head>.");
            form.setAttribute('data-captcha-ready', 'true');
            form.requestSubmit();
        }

        console.groupEnd();
    }, { capture: true });
}